import React from 'react';
import TicketStubHeader from './header';
import CloseIcon from '../icons/icon_close2';
import InfoIcon from '../icons/icon_info';
import Button from '../../common/button';
import Tooltip from '../tooltip';
import get from 'lodash/get';
import {hasMandatoryUpsells, getPriceWithMandatoryUpsells} from './mandatory_upsells_utils';

export default class TicketStubRemoveHeader extends React.Component {
  static propTypes = {
    ticket: React.PropTypes.object,
    onClose: React.PropTypes.func
  };

  static defaultProps = {
    ticket: {}
  };

  renderTooltip = () => {
    let tooltipInfo = [];

    // get price info
    const priceInfo = get(this.props, 'ticket.price.priceInfo');
    if (priceInfo) tooltipInfo = [priceInfo];

    // get additional price info
    const priceTypes = get(this.props, 'ticket.basket.priceTypes', {});
    const priceType = priceTypes[get(this.props, 'ticket.price.priceType')] || {};
    if (priceType.additionalInfo && priceType.additionalInfo.length > 0) {
      tooltipInfo = [...priceType.additionalInfo, ...tooltipInfo];
    }

    if (!tooltipInfo.length) return false;
    const dataId = get(this.props, 'ticket.id', '');

    return <Button
      icon
      data-component="ticket-information-tooltip"
      data-id={`id-${dataId}`}
      className="ticket_stub_remove_header__icon"
    >
      <InfoIcon width={16} height={16} />
      <Tooltip selector={`[data-id="id-${dataId}"]`}>
        {
          tooltipInfo.map(({title, content}) => (
            <div
              key={title}
              className="tooltip__content"
            >
              <div className="tooltip__contentheader">{title}</div>
              <div
                className="tooltip__contentbody"
                dangerouslySetInnerHTML={{ __html: content}}
              />
            </div>
          ))
        }
      </Tooltip>
    </Button>;
  };

  render () {
    let price;

    if (hasMandatoryUpsells(this.props)) {
      price = getPriceWithMandatoryUpsells(this.props);
    }
    else {
      price = get(this.props, 'ticket.price.priceFormatted', '');
    }

    return (
      <TicketStubHeader>
        <div className="ticket_stub_remove_header__price_container">
          <h3
            className="ticket_stub_remove_header__price"
            data-component="ticket-price">{price}</h3>
          {this.renderTooltip()}
        </div>
        <Button
          icon
          onClick={this.props.onClose}
          data-component="ticket-remove-button"
          className="ticket_stub_remove_header__icon">
          <CloseIcon  className="ticket_stub_remove_header__remove_icon" width={16} height={16} />
        </Button>

      </TicketStubHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/ticket_stub_remove_header.js